import React, { useEffect, useState } from "react";

import PermissionSection from "components/PermissionSection";

import { useRecoilValue } from "recoil";
import { sectionsPermissionsAtom } from "stores";

interface PermissionsT {
  defaults?: Array<number>;
  onChange?: (selected: Array<number>) => void;
  editable?: boolean;
}

const Permissions: React.FC<PermissionsT> = ({
  defaults,
  onChange,
  editable = true,
}) => {
  const sectionsPermissions = useRecoilValue(sectionsPermissionsAtom);

  const [selectedIds, setSelectedIds] = useState<Array<number>>(defaults);

  useEffect(() => setSelectedIds(defaults), [defaults]);

  const _onChange = (ids: Array<number>) => {
    setSelectedIds(ids);
    onChange(ids);
  };

  return (
    <>
      {sectionsPermissions?.map((section, key) => (
        <PermissionSection
          key={String(key)}
          section={section}
          selected={selectedIds}
          onChange={editable ? _onChange : null}
        />
      ))}
    </>
  );
};

export default Permissions;
